export enum Company {
  Sea = 'C310',
  Seca = 'C330',
  SeaIm = 'C370'
}
